export default __webpack_public_path__ + "media/images/manual/ic/11-08e6d5d92ca827cd0a4db8ae4095ebd2.png";